"use client";
import React from "react";
import { Box, Typography } from "@mui/material";
import { VERSION } from "../../../config/version";

// Small footer line shown on standalone (no-layout-chrome) pages such as
// /login and /r/[requestId], to match the standard app footer used elsewhere.
export default function AppVersionFooter({ sx = {} }) {
  return (
    <Box
      component="footer"
      sx={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        py: 2,
        ...sx,
      }}
    >
      <Typography variant="caption" sx={{ color: "grey.500" }}>
        © {new Date().getFullYear()} Meex, Inc. — Version {VERSION}
      </Typography>
    </Box>
  );
}
